import React from "react";
import {Header} from "../../layout/Header";
import "./index.scss";
import config from "../../config";
import {getCurrentTimeKyiv} from "../../utils/utils";

export function showOrNotTechnicalWorkPage(signingQuotation?: boolean) {
    return checkAndRedirectToErrorPage(23, signingQuotation ? 45 : 30, config.technicalWorkUrl);
}

export function showOrNotTechnicalWorkPageForGreenCard() {
    return checkAndRedirectToErrorPage(23, 30, config.technicalGreednCardWorkUrl);
}

function checkAndRedirectToErrorPage(hoursToCheck: number, minutesToCheck: number, url: string) {

    const [hourKyiv, minuteKyiv] = getCurrentTimeKyiv();
    console.log("Checking selling time: Not allowed " + hoursToCheck + ":" + minutesToCheck + "-00:00. Current time in Kyiv " + hourKyiv + ":" + minuteKyiv);

    if (hourKyiv >= hoursToCheck && minuteKyiv >= minutesToCheck) {
        window.location.replace(url);
        return true;
    }
    return false;
}

export function showNoProductPage() {
    window.location.replace(config.unavailablePageUrl);
}

export const MessagePage = ({homeUrl, children, type}) => {
    return (
        <div className={"message-page"}>
            <div className={"message-page__header"}>
                <Header homeUrl={homeUrl} type={type}/>
            </div>

            <div className={"message-page__content"}>
                {children}
            </div>
        </div>
    )
};